import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface SessionTokens {
  token: string;
  refreshToken: string;
}

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  currentOrganizationId: string | null;
  isAuthenticated: boolean;
  setSession: (tokens: SessionTokens) => void;
  setOrganizationContext: (organizationId: string | null) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      currentOrganizationId: null,
      isAuthenticated: false,
      setSession: ({ token, refreshToken }) =>
        set({ token, refreshToken, isAuthenticated: true }),
      setOrganizationContext: (organizationId) =>
        set({ currentOrganizationId: organizationId }),
      clearSession: () =>
        set({
          token: null,
          refreshToken: null,
          currentOrganizationId: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: "exhousing-auth",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
        currentOrganizationId: state.currentOrganizationId,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
